import {
  useAccountAPIStore,
  useAccountBalanceAPIStore,
  useAccountTokenAPIStore,
  useCoinAPIStore,
  useCoinPriceAPIStore,
  useInfoAPIStore,
  useNFTAPIStore,
  useNFTContractAPIStore,
  useNoticeAPIStore,
  useProjectAPIStore,
  useTransactionAPIStore,
  useUserAPIStore,
  useWalletAPIStore,
  useBackCountStore,
  useLocaleStore,
  usePopupStore,
  useWalletStore,
  usePinLockStore,
} from '@/stores'

export const useSetupStoreReset = () => {
  useAccountAPIStore().reset()
  useAccountBalanceAPIStore().reset()
  useAccountTokenAPIStore().reset()
  useCoinAPIStore().reset()
  useCoinPriceAPIStore().reset()
  useInfoAPIStore().reset()
  useNFTAPIStore().reset()
  useNFTContractAPIStore().reset()
  useNoticeAPIStore().reset()
  useProjectAPIStore().reset()
  useTransactionAPIStore().reset()
  useUserAPIStore().reset()
  useWalletAPIStore().reset()
  useBackCountStore().reset()
  useLocaleStore().reset()
  usePopupStore().reset()
  useWalletStore().reset()
  usePinLockStore().reset()
}
